export default __webpack_public_path__ + "static/media/princy.baf0e63a.jpeg";